import React from 'react';
import { List, ListItem, ListItemSecondaryAction, ListItemText, ListProps } from '@mui/material';

import { ProductApi } from 'common/types';
import { getRentleSegments } from 'common/utils/segments';
import { useTranslation } from 'services/localization';
import VisibilitySwitch from './VisibilitySwitch';

export interface SegmentVisibilitySettingsProps extends Omit<ListProps, 'onChange'> {
	value: ProductApi['segmentFilters'];
	onChange: (value: ProductApi['segmentFilters']) => void;
	disabled?: boolean;
}
const SegmentVisibilitySettings = (props: SegmentVisibilitySettingsProps) => {
	const { value = [], onChange, disabled, ...listProps } = props;
	const { t } = useTranslation();
	const allSegments = getRentleSegments();

	const isSegmentEnabled = (segment: string) => {
		return value.length === 0 || value.includes(segment);
	};

	const toggleSegment = (segment: string) => (enabled: boolean) => {
		if (enabled) {
			if (value.length >= allSegments.length - 1) {
				onChange([]);
			} else {
				onChange([...value, segment]);
			}
		} else {
			if (value.length === 1) {
				onChange(value);
			} else if (value.length === 0) {
				onChange(allSegments.filter((s) => s !== segment));
			} else {
				onChange(value.filter((s) => s !== segment));
			}
		}
	};

	return (
		<List {...listProps}>
			<List>
				{allSegments.map((segment) => {
					const checked = isSegmentEnabled(segment);
					return (
						<ListItem divider key={segment}>
							<ListItemText
								primary={segment}
								primaryTypographyProps={{ sx: { textTransform: 'capitalize' } }}
								secondary={
									checked && value.length === 1
										? t(
												'product.mustBeVisibleForAtLeastOneSegment',
												'Products must be visible for at least one segment',
										  )
										: ''
								}
							/>
							<ListItemSecondaryAction>
								<VisibilitySwitch
									checked={checked}
									onChange={toggleSegment(segment)}
									disabled={disabled || (checked && value.length === 1)}
								/>
							</ListItemSecondaryAction>
						</ListItem>
					);
				})}
			</List>
		</List>
	);
};

export default SegmentVisibilitySettings;
